import React from "react";

import {
    Row, Col,
    Input,
} from "reactstrap";

import Base64 from '../../common/Base64';
import GoogleDrive from '../../common/GoogleDrive';
import InputBase from "./InputBase";
import Convert from "../../common/Convert";

export default class InputFile extends InputBase {
    
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.defaultValue ? this.props.defaultValue : '',
        };
        this.handle_change = this.handle_change.bind(this);
    }

    executeValidateCallback(text, message){
        const{
            name,
            rootData:{
                requiredData,
                errors,
                values
            }
        } = this.props
        
        const columnObject = Convert.key_split(name)
        
        const error = message?{[columnObject.column]:message}:{}

        const name_base64 = columnObject.column + "_base64"
        
        if (this.props.validateCallback){
            this.props.validateCallback({
                values:{
                    ...values,
                    [columnObject.column]:text,
                    [name_base64]:this.state.base64
                },
                errors:{
                    ...errors&&Object.keys(errors).reduce((acc, key)=>{
                        if (key!==columnObject.column){
                            acc[key]=errors[key]
                        }
                        return acc
                    },{}),
                    ...error
                },
                requiredData:{
                    ...requiredData,
                },
            });
        }
    }

    async handle_change(e) {
        const file = e.target.files[0]||{name:""};
        Base64.getBase64(file, ((result) => {
            this.setState({ base64: result, showLink: false }, () => { this.validate(file.name); });
        }).bind(this));
    }

    componentDidUpdate(prevProps) {
        if(JSON.stringify(this.props) === JSON.stringify(prevProps))
            return;
        const {
            name,
            rootData:{
                values
            }
        } = this.props
        const columnObject = Convert.key_split(name)
        this.setState({
            value: values&&values[columnObject.column],
        });
    }

    render() {
        const{
            label,
            name,
            rootData:{
                errors,
                values
            }
        } = this.props
        const columnObject = Convert.key_split(name)
        const validate_message = errors&&errors[columnObject.column]
        const name_base64 = columnObject.column + "_base64"
        const value = values[columnObject.column]
        const value_base64 = values[name_base64]
        return (
            <>
                <Row style={{margin:0}}>
                    <Col md="9" className="d-flex align-items-center">
                        {this.props.showLink&&!value_base64&&value ? (
                            <a className="link" target='_blank' href={GoogleDrive.file_url(value, this.props.filename)}>{label}</a>
                        ) : (
                            <Input type="text" name={'disp_' + columnObject.column} className="form-control" readOnly value={value} />
                        )}
                    </Col>
                    <Col md="3">
                        <label style={{marginTop: "10px"}}>
                            <span className={`btn btn-secondary btn-sm ${this.props.disabled ? "disabled" : ""}`}>
                                ファイル選択<Input type="file" id={columnObject.column} name={columnObject.column} accept={this.props.accept||"*"} style={{ display: "none" }} onChange={this.handle_change} disabled={this.props.disabled}/>
                            </span>
                        </label>
                    </Col>
                </Row>
                {
                    validate_message instanceof Array && validate_message.length>0 &&
                    <p id={name} style={{ color: "red" }}>{validate_message.length>0?validate_message[0]:validate_message}</p>
                }
            </>
        );
    }
}
